export default __webpack_public_path__ + "static/media/blueMarkTick.67925b48.png";